import { Box } from '@factorialco/deprecated-design-system'
import { BaseBanner } from '@factorialco/f0-react/dist/experimental'
import BannerVerifactu from 'assets/images/finance/financial_documents/banner-verifactu.png'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'
import { useNavigate } from 'react-router-dom'

interface VerifactuRegistrationBannerProps {
  visible: boolean
  source: string
}

export const VerifactuRegistrationBanner = ({
  visible,
  source,
}: VerifactuRegistrationBannerProps) => {
  const [isHidden, setIsHidden] = useLocalStorage<boolean>(
    `factorial:sales-verifactu-registration-${source}`
  )
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const clickLink = () => {
    navigate(navigation.settings.finance.sales.fullPath())
  }

  const onClose = () => {
    setIsHidden(true)
  }

  if (!visible || isHidden) return null

  return (
    <Box width="full" paddingBottom="s16">
      <BaseBanner
        title={i18n.t('finance.sale_invoices.settings.verifactu.registration_banner.title')}
        subtitle={i18n.t('finance.sale_invoices.settings.verifactu.registration_banner.description')}
        mediaUrl={BannerVerifactu}
        secondaryAction={{
          label: i18n.t('finance.sale_invoices.settings.verifactu.registration_banner.link'),
          onClick: clickLink,
        }}
        onClose={onClose}
      />
    </Box>
  )
}
